// The nearest scrollable ancestor's viewport rect, or null. Used to keep a
// portaled dropdown panel inside (say) a modal body rather than measuring
// against the whole window — otherwise a control near the modal's bottom sees
// the large backdrop area below it as "room" and opens over the modal's
// footer. DOM-touching, so it lives beside the components; the pure placement
// maths is in ../lib/dropdownPlacement.ts.
export function scrollableBoundary(el: HTMLElement): DOMRect | null {
  let node = el.parentElement;
  while (node) {
    const oy = getComputedStyle(node).overflowY;
    if (oy === 'auto' || oy === 'scroll') return node.getBoundingClientRect();
    node = node.parentElement;
  }
  return null;
}
